var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import { Router } from 'react-router';
import { Viewport } from '../viewport';
import { services } from '@comall-backend-builder/core';

var AntdEntry = function (_super) {
  __extends(AntdEntry, _super);

  function AntdEntry() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AntdEntry.prototype.render = function () {
    var _a = this.props,
        history = _a.history,
        routes = _a.routes,
        store = _a.store;
    return React.createElement(Provider, {
      store: store
    }, React.createElement(ConfigProvider, {
      locale: services.language.getCurrentLanguage().antdLocale
    }, React.createElement(Router, {
      history: history
    }, React.createElement(Viewport, {
      routes: routes
    }))));
  };

  return AntdEntry;
}(React.Component);

export { AntdEntry };